import { Directive, ElementRef, HostListener } from '@angular/core';
import { formatSSNDigits } from '../functions';

@Directive({
  selector: '[ssnMask]',
  standalone: true
})
export class SsnMaskDirective {
  private lastValue = '';

  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = this.el.nativeElement;
    const raw = input.value;
    const selectionStart = input.selectionStart ?? raw.length;

    // count digits to left of caret
    const digitsBefore = (raw.slice(0, selectionStart).match(/\d/g) || []).length;

    const formatted = formatSSNDigits(raw);

    // Prevent infinite loop: only update when formatted differs from lastValue
    if (formatted === this.lastValue) {
      return;
    }

    this.lastValue = formatted;

    // Update the visible value
    input.value = formatted;

    // compute new caret position so that same number of digits are before it
    if (digitsBefore === 0) {
      input.setSelectionRange(0, 0);
    } else {
      let digitsSeen = 0;
      let newPos = formatted.length;
      for (let i = 0; i < formatted.length; i++) {
        if (/\d/.test(formatted[i])) digitsSeen++;
        if (digitsSeen === digitsBefore) { newPos = i + 1; break; }
      }
      newPos = Math.max(0, Math.min(newPos, formatted.length));
      input.setSelectionRange(newPos, newPos);
    }

    // Only dispatch if the formatted value actually changed compared to the original raw value.
    // This will trigger formControl update but next onInput will exit early due to lastValue check.
    if (formatted !== raw) {
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
}